<template>
  <v-container fluid>
    <v-dialog v-model="dialog" max-width="80vw">
      <!-- <v-btn slot="activator" color="primary" dark class="mb-2" @click="addEntry">New Dealer</v-btn> -->
      <v-card>
        <v-card-title>
          <v-title>
            Dealer Logins
          </v-title>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" lazyValidation>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-text-field
                    name="ubDealerID"
                    v-model="editedItem.ubDealerID"
                    label="Dealer ID"
                    v-validate="'required'"
                    :error-messages="errors.collect('ubDealerID')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="editedItem.dealerFullName"
                    label="Full Name"
                    v-validate="'required'"
                    name="dealerFullName"
                    :error-messages="errors.collect('dealerFullName')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-text-field
                    v-model="editedItem.lastLoggedIn"
                    name="lastLoggedIn"
                    label="Last Logged In Date"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="dealerEmail"
                    v-model="editedItem.dealerEmail"
                    label="dealerEmail"
                    v-validate="'required'"
                    :error-messages="errors.collect('dealerEmail')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    color="success"
                    @click="getContract(editedItem.ubDealerID)"
                    >Get Contract</v-btn
                  >
                </v-flex>
                <hr />
                <v-flex xs12>
                  <auth-details :dealer="editedItem"></auth-details>
                </v-flex>

                <v-spacer>
                  <v-title>Auth0 Functions</v-title>
                </v-spacer>
                <v-flex xs12>
                  <v-btn
                    color="secondary"
                    @click="searchAuth0(editedItem.dealerEmail)"
                    >Check Login Email</v-btn
                  >
                  <v-btn
                    color="secondary"
                    @click="createAuth(editedItem.dealerEmail)"
                    >Create Login Account</v-btn
                  >
                  <v-btn
                    color="secondary"
                    @click="resetPassword(editedItem.dealerEmail)"
                    >Reset Login Password</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="save">Save</v-btn>
          <v-btn color="light-grey" @click.native="save">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from "vuex";
import { mapMultiRowFields } from "vuex-map-fields";
import {
  mapDealerFields,
  mapDealerMultiRowFields
} from "../../store/modules/orders";

const {
  mapActions: mapDealerActions,
  mapMutations: mapDealerMutations
} = createNamespacedHelpers(`orders/dealer`);
import { httpError } from "../../models/httpError";
import { Dealer } from "../../models/Dealer";
import AuthDetails from "../admin/auth-details";
export default {
  name: "editDealerDialog",
  components: {
    AuthDetails
  },
  data: () => ({
    editedItem: new Dealer(),
    editedIndex: 0
  }),

  computed: {
    ...mapDealerFields(["message"]),
    ...mapDealerMultiRowFields({
      rows: "dealers"
    }),
    filteredRows: function() {
      let vm = this;
      return vm.rows.filter(this.isValid);
    }
  },

  methods: {
    ...mapDealerActions([
      "listDealers",
      "saveDealer",
      "setMessage",
      "resetPassword",
      "searchAuth0",
      "createAuth",
      "getContract",
      "removeDealer"
    ]),

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      let vm = this;
      vm.$validator.validateAll().then(async result => {
        if (result) {
          vm.saveDealer(this.editedIndex)
            .then(() => this.close())
            .catch(() => this.close());
        }
      });
    }
  },
  mounted() {
    let vm = this;
    this.$nextTick(() => {
      vm.setMessage(new httpError());
      vm.getDataFromApi();
    });
  }
};
</script>
